import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Route, Switch} from 'react-router';

import * as selector from '../selectors';

import Question from './review/Question';
import Links from './review/Links';
import Like from './review/Like';
import Dislike from './review/Dislike';
import NotFound from './NotFound';

@connect(state => ({
	location: selector.getLocation(state),
}))
export default class extends Component {
	static propTypes = {
		location: PropTypes.object,
	}

	render() {
		const {location} = this.props;
		const backRoute = location.pathname === '/review' ? '/' : '/review';

		return (
			<Fragment>
				<div className="container">
					<Switch>
						<Route exact path='/review' component={Question} />
						<Route exact path='/review/links' component={Links} />
						<Route exact path='/review/like' component={Like} />
						<Route exact path='/review/dislike' component={Dislike} />
						<Route component={NotFound} />
					</Switch>
				</div>
				<Link to={backRoute} className="back" title="Назад" />
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Review.js